import React from "react";
import { useAuth } from "../../context/AuthContext";
import { setCompanyContext } from "../../services/apiClient";

export default function CompanySwitcher() {

  const {
    companies = [],
    companyId,
    selectCompany,
  } = useAuth();

  /* ------------------------------------------------------ */
  /* Handle Company Switch                                  */
  /* ------------------------------------------------------ */

  const handleSwitch = (e) => {

    const newCompanyId = e.target.value;

    if (!newCompanyId || newCompanyId === companyId) return;

    /* Update context */

    selectCompany(newCompanyId);

    /* Update API header */

    setCompanyContext(newCompanyId);

    /* Reload app state */

    window.location.reload();
  };

  /* ------------------------------------------------------ */
  /* No Companies                                           */
  /* ------------------------------------------------------ */

  if (!companies.length) {
    return null;
  }

  /* ------------------------------------------------------ */
  /* UI                                                     */
  /* ------------------------------------------------------ */

  return (
    <div className="flex items-center gap-2">

      <span className="text-xs text-gray-500 hidden md:block">
        Company
      </span>

      <select
        value={companyId || ""}
        onChange={handleSwitch}
        className="
          border
          rounded-lg
          px-3
          py-1.5
          text-sm
          bg-white
          focus:outline-none
          focus:ring-2
          focus:ring-orange-200
        "
      >

        {companies.map((company) => (

          <option key={company._id} value={company._id}>
            {company.name}
          </option>

        ))}

      </select>

    </div>
  );

}